<div class="search-box">
    <ax-text-box [(text)]="text" (onKey)="onSearchChanged($event)" [showClear]="showClear" placeholder="Search ...">
        <ax-button type="light">
            <i class="fas fa-search"></i>
        </ax-button>
    </ax-text-box>
</div>